export enum UserCompanyTypeEnum {
  customer = 0,
  agency = 1,
  unassigned = 2,
  admin = 3
}
